<script>
    import { setContext } from "svelte";
    import { onMount } from "svelte";
    import { text } from "svelte/internal";
    import Hud from "./Hud.svelte";
    import Chat from "./Chat.svelte";
    import Test from "./Test.svelte";
    import lancementjeu from "./Test.svelte";
    import io from "socket.io-client";
    import { Allier, Personnage, Objet, chatouvert } from "./Class.js";
    import { socket, sauvegarde } from "./Variables.js";
    import { location } from "svelte-spa-router";
    export let connecter;
    export let joueur;
    let connexionerror = false;
    // export const socket = io("https://apiildaa.herokuapp.com");
    // setContext("socket", socket);
    export let nbjoueurenligne;
    export let joueurenligne = [];

    //TODO ------------------------------------------------------------------------------- SONO -------------------------
    joueur = new Personnage("invité", 0, 1);

    let effet = [
        new Audio("son/effet/ambiance.mp3"),
        new Audio(""),
        new Audio("son/effet/chat.mp3"),
        new Audio("son/effet/validation3.mp3")
    ];
    let ildaa = [
        new Audio("son/effet/ildaabonjour.mp3"),
        new Audio("son/effet/ildaastrategie.mp3"),
        new Audio("son/effet/ildaacybershop.mp3"),
        new Audio("son/effet/ildaastrategie.mp3")
    ];
    let nbclient;
    $: nbactuel = nbjoueurenligne;
    $: joueurlive = joueurenligne;
    setContext("joueurenligne", joueurenligne);
    // CONNEXION EN JEU
    function testsocket() {
        let infos = {
            nom: joueur.pseudo,
            nb: nbjoueurenligne,
            id: joueur.pseudo
        };
        socket.on("disconnect", () => {
            socket.emit("deco", joueur.pseudo);
        });

        socket.emit("connexionenjeu", infos);
    }
    socket.on("connect", () => {
        socket.on("alerteconnexion", (data) => {
            // console.log(data.nb);
            console.log(data.joueurs);

            joueurenligne = data.joueurs;
            nbjoueurenligne = data.nb--;
        });
        socket.on("alertedeconnexion", (data) => {
            nbjoueurenligne--;
            joueurenligne = data.joueurs;
        });

        // console.log("connection établie avec ildaa"); // true
    });

    //TODO ------------------------------------------------------------------------------- App and variables -------------------------

    let src = "/img/persoface.png";
    let classbouttonquitter = "bouttoncaché";
    let classbouttonconnexion = "";
    let pseudo;

    let chargementindicateur = false;
    $: connectionactive = connecter;
    connecter = false;
    let menucache = false;
    let hudcache = true;
    let titrecache = false;
    setContext("hudcache", hudcache);
    function enregistrementjoueur(
        pseudo,
        cyberz,
        niveau,
        sante,
        attaque,
        defense,
        xp,
        pass,
        inventaire,
        kill,
        score,
        puce,
        amelioration,
        relique
    ) {
        fetch("https://apiildaa.herokuapp.com/connectionjoueur", {
            method: "post",
            mode: "cors",
            headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                pseudo: pseudo,
                cyberz: cyberz,
                niveau: niveau,
                sante: sante,
                attaque: attaque,
                defense: defense,
                xp: xp,
                pass: pass,
                inventaire: inventaire,
                kill: kill,
                score: score,
                puce: puce,
                amelioration: amelioration,
                relique: relique
            })
        })
            .then((res) => res.json())
            .then((res) => {
                if (res === "error") {
                    console.log("erreur pseudo ou pass erroné");
                    chargementindicateur = false;
                    connexionerror = true;
                    return "error";
                } else {
                    let response = [];
                    response.push(res);
                    if (res.compte != undefined) {
                        /* console.log("nouveau compte créer"); */
                        connectionactive === true;
                    }
                    joueur.pseudo = res.pseudo;
                    joueur.cyberz = res.cyberz;
                    joueur.niveau = res.niveau;
                    joueur.sante = res.sante;
                    joueur.attaque = res.attaque;
                    joueur.defense = res.defense;
                    joueur.xp = res.xp;
                    joueur.pass = res.pass;
                    joueur.inventaire = res.inventaire;
                    joueur.kill = res.kill;
                    joueur.score = res.score;
                    joueur.puce = res.puce;
                    joueur.amelioration = res.amelioration;
                    joueur.relique = res.relique;
                    chargementindicateur = false;
                    connecter = true;
                    menucache = true;
                    titrecache = true;
                    effet[0].volume = 0.3;
                }
                /* console.log(res); */

                /* console.log(res.pseudo); */

                /* console.log(joueur.inventaire.length); */
                setInterval(() => {
                    effet[0].play();
                }, 1000);
                setTimeout(() => {
                    ildaa[0].volume = 0.5;
                    ildaa[0].play();
                }, 2000);
            });
    }

    const valider = function (event) {
        if (event.keyCode === 13) {
            /* console.log("entrer appuyé");
            console.log(event); */
        }
    };

    let objet = new Objet("Carte d'agent", 20, "img/carteagent.png");
    joueur.inventaire.push(objet);

    setContext("joueur", joueur);

    let message = [
        "Onixyum ",
        "Nouveau sur Onixyum ?",
        "Mauvais pass ou pseudo déjà pris",
        "Un Pseudo*, un Pass* et c'est parti !"
    ];

    onMount(async () => {});

    //TODO ------------------------------------------------------------------------------- HTML -------------------------
</script>

<svelte:window on:keydown={() => {}} on:mousemoove={() => {}} />

<!-- <Hud pseudo ={pseudo}/> -->

<div id="ecran" />
<div id="menu" class={menucache ? "menucache" : ""}>
    <div class="info">
        <p>{message[0]}</p>
    </div>

    <input
        placeholder="Pseudo*"
        bind:value={joueur.pseudo}
        id="input3"
        maxlength="9"
        on:keypress={(e) => {
            valider(e);
        }}
        autocomplete="off"
        onfocus="this.value=''"
    />
    <input
        placeholder="Pass*"
        bind:value={joueur.pass}
        id="input"
        maxlength="9"
        autocomplete="off"
        onfocus="this.value=''"
    />
    <button
        class={classbouttonconnexion}
        id="connexionboutton"
        on:click={() => {
            effet[3].volume = 0.5;
            effet[3].play();
            enregistrementjoueur(
                joueur.pseudo,
                joueur.cyberz,
                joueur.niveau,
                joueur.sante,
                joueur.attaque,
                joueur.defense,
                joueur.xp,
                joueur.pass,
                joueur.inventaire,
                joueur.kill,
                joueur.score,
                joueur.puce,
                joueur.amelioration,
                joueur.relique
            );

            {
                chargementindicateur = true;
                // hudcache = false;
            }
            {
                classbouttonquitter = "";
            }
            {
                classbouttonconnexion = "bouttoncaché";
            }
            testsocket();
        }}>Connexion</button
    >

    <div class="info2">
        <p class="textinfo">{message[1]}</p>
        <img src="img/infoobjet.png" alt="" />
    </div>
    {#if connexionerror}
        <p class="textinfoerror">{message[2]}</p>
        <button
            id="recommencer"
            on:click={(event) => {
                window.location.reload();
            }}>recommencer</button
        >
    {/if}
    <img
        src="/img/glitter3.png"
        alt=""
        id="indicateur"
        class={chargementindicateur === true ? "indicateurtourne" : "indicateur"}
    />
</div>

<div id="jeu">
    <Test id="test" lancementjeu={connecter} />
    <div id="titre" class={titrecache ? "menucache" : ""}><img src="/img/titre2.png" alt="" /></div>
    <div id="joueurenligne">
        <p id="nbjoueur" class={!menucache ? "menucache" : ""}>
            <span> En ligne : </span>
            {nbactuel}
        </p>
    </div>
</div>

<!-- <img src="/img/tokyo.png" alt="">
<img src="/img/tokyo.png" alt=""> -->
<style>
    @font-face {
        font-family: "scifi";
        src: url("/conthrax-sb.ttf");
    }
    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes chatapparition {
        from {
            text-shadow: 1px 1px 9px rgb(0, 0, 0);
        }
        to {
            text-shadow: 3px 5px 9px rgb(0, 0, 0);
        }
    }
    .textinfoerror {
        font-size: 11px;
    }
    #recommencer:hover {
        color: rgb(255, 0, 0);
        box-shadow: 0px 0px 10px rgb(255, 0, 0), 0px 0px 10px #000000;
    }
    #recommencer {
        position: absolute;
        top: 340px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    #connexionboutton {
        margin-top: 15px;
        margin-bottom: 20px;
    }
    #connexionboutton:hover {
        color: rgb(255, 0, 0);
        box-shadow: 0px 0px 10px rgb(255, 0, 0), 0px 0px 10px #000000;
    }

    #ecran {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
    }
    .info2 {
        position: relative;
    }
    p {
        color: red;
    }
    .indicateur {
        margin-top: 12px;
    }
    #nbjoueur {
        color: rgb(150, 255, 80);
        text-shadow: 1px 2px 9px rgb(0, 0, 0);
    }

    #conainermessagechat {
        width: 500px;
        box-sizing: border-box;
        padding: 5px;
    }
    #input2 {
        color: #000000;
        font-size: 15px;
        box-shadow: 0px 0px 10px rgb(0, 0, 0), 0px 0px 10px #000000;
        background-color: rgba(233, 227, 225, 0.342);
    }
    input {
        margin-bottom: 15px;
    }
    .textinfo {
        color: white;
        font-size: 13px;
    }

    .messagedechat {
        text-shadow: 1px 1px 9px rgb(0, 0, 0);
        color: rgb(255, 255, 255);
        width: 100%;
        font-size: 17px;
        font-weight: bold;
        animation: chatapparition infinite 3s alternate linear;
        font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande", "Lucida Sans Unicode",
            Geneva, Verdana, sans-serif;
        overflow-x: hidden;
    }

    .info {
        text-align: center;
        font-size: 15px;
        color: rgb(255, 255, 255);
        text-shadow: 6px 5px 4px black;
        margin-top: 15px;
        line-height: 19px;
    }
    .info2 > img {
        position: absolute;
        top: 17px;
        right: 9px;
        cursor: url("/img/mouse2.png"), pointer;
    }
    .info2 > img:hover {
        box-shadow: 0px 0px 10px rgb(255, 0, 0), 0px 0px 10px #000000;
        background-color: black;
        border-radius: 45%;
        width: fit-content;
    }
    .info > p {
        align-self: center;
        justify-self: center;
        text-align: center;
        padding: 10px;
        font-size: 17px;
    }

    button {
        font-family: "scifi";
        box-shadow: 0px 0px 10px rgb(0, 0, 0), 0px 0px 10px #000000;
        background-color: black;
        border-radius: 12px;
        cursor: url("/img/mouse2.png"), pointer;
        color: rgb(92, 255, 247);
    }
    #hud {
        z-index: 2;
        font-family: "scifi";
        left: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .bouttoncaché {
        display: none;
        z-index: 0;
        cursor: initial;
    }

    .indicateurtourne {
        animation: tourner infinite 0.2s linear;
    }
    #menu {
        left: 70px;
        top: 195px;
        padding-top: 15px;
        row-gap: 20px;
        width: 180px;
        height: 350px;
        margin: 5px;
        background-color: rgba(71, 71, 71, 0.26);
        z-index: 3;
        position: fixed;

        flex-direction: column;
        align-items: center;
        font-family: "scifi";
        border: solid 1px rgb(179, 0, 0);
        border-radius: 12px;
        font-family: "scifi";
        box-shadow: 0px 0px 10px rgb(0, 0, 0), 0px 0px 10px #000000;
    }
    .menucache {
        display: none;
        cursor: initial;
        z-index: 0;
        margin-right: 333px;
    }
    input {
        width: 70%;
        font-size: 15px;
        font-family: "scifi";
        box-shadow: 0px 0px 10px rgb(0, 0, 0), 0px 0px 10px #000000;
        background-color: rgb(39, 39, 39);
        outline: none;
        color: rgb(255, 255, 255);
        text-shadow: 0.4px 0.4px rgb(0, 0, 0);
    }
    input::placeholder {
        color: #000000;
    }

    #jeu {
        display: flex;
        justify-content: center;
        position: absolute;

        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    #titre {
        top: 50px;
        position: absolute;
        justify-self: center;
        align-self: center;
        color: aliceblue;
        z-index: 3;
    }
    #titre img {
        animation: briller infinite 2s linear;
        animation-direction: alternate;
        /* animation-iteration-count: 5; JOUE LANIMATION 5 SEC ET ARRETE*/
        margin: auto;
    }

    #joueurenligne {
        height: fit-content;

        position: absolute;

        border-radius: 12px;
        color: chartreuse;

        font-size: 10px;
        z-index: 2;
    }
    #joueurenligne span {
        color: rgb(255, 255, 255);
        margin: 2px;
    }

    #ecran {
        font-family: "scifi";
    }
    #test {
        position: absolute;
    }

    @keyframes marche {
        from {
        }
        to {
            background-position-x: 48px;
        }
    }

    @keyframes briller {
        from {
            opacity: 30%;
        }
        to {
            opacity: 100%;
        }
    }

    @keyframes tourner {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
